import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const FormsStyles = styled.div`
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 15px 0 rgb(0, 0, 0, 0.14);
  box-sizing: border-box;
  margin: 15px;
  max-width: 400px;
  padding: 0 25px 25px;

  &.no-forms {
    height: 325px;
  }
  .cards-container {
    padding-bottom: 40px;
  }
  .form-header {
    border-bottom: 1px solid ${Colors.accent.grey5.standard};
    margin: 0 -25px 42px; /* minus container padding */
    width: calc(100% + 50px); /* plus container padding - 2 sides */

    span {
      align-items: center;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      max-width: 180px;
    }
    svg {
      height: 20px;
      margin-right: 5px;
      width: 20px;
    }
    .heading-component {
      min-width: calc(100% - 25px);
      text-align: left;
    }
    h5 {
      margin: 25px 0;
      vertical-align: middle;
    }
  }
  .help-header {
    text-align: center;

    .body-copy-component {
      margin-bottom: 10px;
    }
  }
  button {
    margin-top: 30px;
    text-transform: uppercase;
  }
  .preferred-contact,
  .radios label {
    font-family: 'source-sans-pro', sans-serif !important; /* overriding iOS defaults */
  }
  .help-link {
    color: ${Colors.primary.black.standard};
    font-family: 'source-sans-pro', sans-serif;
    font-size: 12px;
    line-height: 1.42;
    position: relative;
    top: -10px;
    cursor: pointer;

    svg {
      margin-right: 5px;
      margin-bottom: -5px;
    }
  }
  .comments {
    .animated.error {
      textarea {
        border-bottom: 1px solid #ef4b5d;
      }
    }
  }
  textarea {
    margin: 10px 0 0 0;
  }
  .terms-error,
  .contact-error {
    color: #bc2636;
    font-family: 'source-sans-pro', sans-serif;
    font-size: 12px;
  }
  /* .contact-error {
        margin-top: -10px;
    } */
  .terms-error {
    margin-left: 29px;
  }

  .terms-container {
    display: flex;
    p {
      margin-top: -2px;
    }
  }
  .selectable-card {
    align-items: center;
    display: flex;
    height: 58px;
    justify-content: center;
    margin: 0 auto 10px;
    max-width: 280px;
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    margin: 15px auto;
  }
  @media only screen and (min-width: 500px) {
    max-width: 480px;
  }
  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    margin: 0 50px 60px 0;
    max-width: 575px;
    padding: 0 55px 55px;
    width: calc(60% - 50px);

    &.no-forms {
      height: 250px;
    }
    .form-header {
      margin: 0 -55px 42px; /* minus container padding */
      width: calc(100% + 110px); /* plus container padding - 2 sides */
    }
    .cards-container {
      display: flex;
      justify-content: space-between;
    }
    .shared-form-fields {
      .shared-form-fields-row {
        display: flex;
        justify-content: space-between;

        .form-field {
          width: 48%;
        }
      }
    }
    .selectable-card {
      margin: 0 5px 10px;
      width: calc(50% - 10px);
    }
  }
`;

export default FormsStyles;
